const deviceType = IsPC()?'pc':'mobile'
const host = process.env.NODE_ENV == 'development' ? 'http://action.op.dianhun.cn/202109/birth/public/index.php/api' : 'https://m3guo.17m3.com/202109/birth/public/index.php/api';
const userPublic = process.env.NODE_ENV == 'development' ? 'http://action.op.dianhun.cn/common/pool/public/index.php/api' : 'https://m3guo.17m3.com/common/pool/public/index.php/api';
const webUrl = process.env.NODE_ENV == 'development' ? 'http://192.168.217.171:9000/' : 'https://www.m3guo.com/activity/202309/team134b2fb/';
const domain = deviceType == 'pc' ? webUrl + 'index.html' : webUrl + 'm.html';

const activityTime = '9月1日-9月28日';

const getQueryVariable = function (variable) {
    var query = window.location.search.substring(1) || window.location.hash.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
        return pair[1];
        }
    }
    return '';
}

const wx_share_text = {
  title: '群贤毕至 共襄盛举', // 分享标题
  desc: '加入周年梦之小队，免费解锁共襄盛举大礼包', // 分享描述
  imgUrl: 'https://web-resource.17m3.com/m3guo/202309/team/sns.jpg', // 分享图标   
}

const ver = '2023820';

const ajax_url_map = {
  
  login: userPublic + '/user/login/login?callback=' + encodeURIComponent(domain) + '&ver=' + ver, //login
  queryplayer: host + '/user/getM3gName', //游戏角色查询接口（需要大区id）
  userinfo : host + '/user/getUserInfo', //查询角色信息
  bind: host + '/user/bind',//绑定大区
  teaminfo: host + '/user/getUserTeam',//获取用户队伍信息
  invite: host + '/user/request',//发出邀请
  accept : host + '/user/acceptRequest',//接受邀请
  invite_info : host + '/user/getRequestInfo',//获取邀请信息接口
  share : host + '/user/share',//获取分享信息
  share_gift : host + '/user/acceptShare',//领取分享奖励
  sign_gift : host + '/user/sign',//领取签到奖励
  team_gift : host + '/user/team',//领取组队奖励
  lottery_code : host + '/user/getLucky',//获取抽奖码
  team_gift_week : host + '/user/getTeamBoon',//领取小队福利包
  buy : host + '/user/buyTeamBuy',//购买小队特惠包
  token_info : host + '/user/getUserCurrencyInfo',//获取用户契约值信息
  token_gift_team : host + '/user/getTeamSuccessBoon',//领取组队契约值奖励
  token_gift_login : host + '/user/getGameLoginBoon',//领取登录游戏契约值奖励
  token_gift_win : host + '/user/getGameWinBoon',//领取胜利对局契约值奖励
  token_gift_buy : host + '/user/getTeamBuyBoon',//领取购买小队礼包契约值奖励
  token_gift_personal : host + '/user/getCurrencyBoon',//领取个人契约值达标奖励
  token_gift_players : host + '/user/getTeamCurrencyBoon',//领取团队契约值达标奖励
  team_pack_gift : host + '/user/getSpecial',//领取购买特惠包奖励
  corp_gift : host + '/user/getCorpBoon',//领取军团齐心礼
  corp_pack : host + '/user/buyCorpBuy',//购买军团内购礼
  luck_list : host + '/user/getLucky',//获取抽奖码
  free: userPublic + '/user/login/pocket', //口袋自登录验证 
  mplat : userPublic + '/user/login/platform',//梦平台验证
  tips : 'https://tool.m3guo.com/api/web/m3goods/eq-item/',//tip获取
}

const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const param =  function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
    '=' + encodeURIComponent(json[key])
  })).join('&')
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
}

const areaList = [{
  "id": 1,
  "name": "火烧赤壁"
}, {
  "id": 2,
  "name": "草船借箭"
}, {
  "id": 6,
  "name": "荆州之战"
}, {
  "id": 7,
  "name": "青梅煮酒"
}, {
  "id": 11,
  "name": "九伐中原"
}, {
  "id": 16,
  "name": "怀旧服"
}, {
  "id": 8,
  "name": "官渡之战"
}, {
  "id": 9,
  "name": "桃园结义"
}, {
  "id": 19,
  "name": "火凤燎原"
}, {
  "id": 20,
  "name": "卧龙出渊"
},
{
  "id": 21,
  "name": "长生殿(Steam)"
}, 
{
  "id": 17,
  "name": "铜雀台(wegame1)"
}, {
  "id": 18,
  "name": "凤仪亭(wegame2)"
}, {
  "id": 100,
  "name": "TEST_1"
}, {
  "id": 110,
  "name": "TEST_2"
}
]

const queryArea = function (num){
  var area = '暂无大区信息';

  if (num == 1) {
      area = '火烧赤壁';
  } else if (num == 2) {
      area = '草船借箭';
  } else if (num == 6) {
      area = '荆州之战';
  } else if (num == 7) {
      area = '青梅煮酒';
  } else if (num == 8) {
      area = '官渡之战';
  } else if (num == 9) {
      area = '桃园结义';
  } else if (num == 11) {
      area = '九伐中原';
  } else if (num == 12) {
      area = '逐鹿中原';
  } else if (num == 13) {
      area = '三分天下';
  } else if (num == 16) {
      area = '怀旧服';
  }else if (num == 17) {
      area = '铜雀台';
  } else if (num == 18) {
      area = '凤仪亭';
  }else if (num == 19) {
      area = '火凤燎原';
  }else if (num == 20) {
      area = '卧龙出渊';
  }else if (num == 21) {
      area = '长生殿';
  }else if (num == 100 || num == 101) {
      area = '测试大区';
  }

  return area;
}


export default {
    ajax_url_map,
    getQueryVariable,
    domain,
    param,
    deviceType,
    areaList,
    ver,
    wx_share_text,
    queryArea,
}


// WEBPACK FOOTER //
// ./src/assets/js/global.js